export default {
    NewImage : 'NewImage',
    EditedImage : 'EditedImage',
}